const DEFAULT_GEOMETRY = {  // Częstochowa
    "location": {"lat": 50.8118195, "lng": 19.1203094},
    "viewport": {"south": 50.7293083, "west": 19.0104358, "north": 50.889333, "east": 19.2351065}
}
const DEFAULT_ZOOM = 13;

const _scroll_to_place = (map, geometry) => {
    if (geometry.viewport) {
        map.fitBounds(geometry.viewport);
    } else {
        map.setCenter(geometry.location);
        map.setZoom(17);
    }
};
const _show_marker = (marker, geometry) => {
    marker.setPosition(geometry.location);
    marker.setVisible(true);
};
const _show_infoWindow = (map, marker, infoWindow, infoWindowContent, name, address, premalink) => {
    infoWindowContent.children['google-maps-place-link'].href = premalink;
    infoWindowContent.children['google-maps-place-link'].children['google-maps-place-name'].textContent = name;
    infoWindowContent.children['google-maps-place-address'].textContent = address;
    infoWindow.open(map, marker);
}

const _get_address = (place) => {
    return place.address_components ? [
        (place.address_components[0] && place.address_components[1].short_name || ''),
        (place.address_components[1] && place.address_components[0].short_name || ''),
    ].join(' ') : '';
};

const _save_geometry = (geometry, address) => {
    const $output_address = $('#parkland-inwestycje-on-the-map-address');
    const $output_geometry = $('#parkland-inwestycje-on-the-map-geometry');
    $output_geometry.val(JSON.stringify(geometry));
    $output_address.val(address);
};

const _prevent_submit_on_enter = (input) => {
    // For whatever reason maps api submits form on pressing enter. Prevent it.
    google.maps.event.addDomListener(input, 'keydown', function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    });
};

export {
    DEFAULT_GEOMETRY,
    DEFAULT_ZOOM,
    _scroll_to_place,
    _show_marker,
    _show_infoWindow,
    _save_geometry,
    _prevent_submit_on_enter,
    _get_address,
}
